import { DiToken, registerDiToken } from '@v2/utilities/di/di-token';

export type Project = {
  jsPath: string;
  cssPath: string;
};

export const PROJECT: DiToken<Project> = new DiToken<Project>('Project');

export function registerProject(options: Project): void {
  registerDiToken(PROJECT, () => options);
}
